<template>
    <div class="orientation modal" @click="outsideClick()">
        <div class="orientation modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
          <div class="orientation modal-body" v-if="shippingType === 3">
            <div class="text" >
              <h5>Que bom que você chegou até aqui, agora é com a gente!</h5>
              <p>Fique tranquilo que o nosso parceiro fará o envio da sua amostra para o nosso laboratório.</p>
              <p>Assim que recebermos sua coleta, iremos aferir seus exames e disponibilizá-los aqui no seu perfil mesmo.
                Você será notificado por e-mail e WhatsApp quando os resultados estiverem disponíveis para consulta.</p>
              <p>Agora é só aguardar e em poucos dias você receberá os resultados.</p>
            </div>
            <div class="form-actions">
              <button class="button btn-primary" @click="$emit('close')">Entendi</button>
            </div>
          </div>
            <div class="orientation modal-body" v-if="shippingType !== 3">
                <div class="text" >
                    <p>Lembre-se que a sua região está coberta pelo sistema de envios dos correios!</p>
                    <p>Para seguir adiante, você já deve ter realizado sua coleta corretamente, esperado o tempo recomendado de 1 hora para
                        secagem do cartão de coleta e colocado o mesmo dentro do saco hermético metalizado.</p>
                    <p>Tudo pronto? <span class="bold">Então, com sua amostra devidamente embalada dentro do envelope preto, dirija-se a uma agência dos correios para encaminhar
                        o seu exame ao laboratório.</span>
                    </p>
                    <div class="image">
                        <img src="@/assets/images/correios_3.png">
                    </div>
                </div>
                <div class="text">
                    <p >Não esqueça de levar junto a sua "SOLICITAÇÃO DE AUTORIZAÇÃO DE POSTAGEM EM AGÊNCIA" que foi encaminhada junto com o seu Kit.</p>
                    <p >E, qualquer dúvida pode entrar em contato com nosso SAC, viu? Teremos prazer em te auxiliar.</p>
                    <div class="image">
                        <img src="@/assets/images/correios_2.png">
                    </div>
                </div>
                <div class="form-actions">
                    <button class="button btn-primary" @click="$emit('close')">Entendi</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {  },
        props: {
          shippingType: null
        },
        data() {
            return {
            }
        },
        methods: {
          outsideClick() {
            if(event.target === event.currentTarget)
                  this.$emit('close');
          },
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .orientation .modal-box {
        max-height: 600px;
    }
    .orientation .modal-body {
        max-width: 800px;
        overflow-y: auto;
    }
    .orientation .modal-body .image {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
    }
    .orientation .modal-body img {
        width: 80%;
    }
</style>



// WEBPACK FOOTER //
// src/components/OrientationModal/OrientationModal.vue